const codigosLiberados = ["90221239", "0007368611", "1597532846"];

const isQa = import.meta.env.VITE_MODE === "qa" || window.location.hostname === "localhost";

const normalizarCodigo = (valor) => String(valor ?? "").trim().replace(/^0+/, "");

const codigoDoUsuario = (usuario) =>
  usuario?.codigo ?? usuario?.codigoUsuario ?? usuario?.usuarioCodigo ?? usuario?.id ?? null;

const usuarioEmCache = () => {
  try {
    return JSON.parse(localStorage.getItem("usuario-cache"));
  } catch {
    return null;
  }
};

export const podeEscolherFonte = (usuario) => {
  if (!isQa) return false;

  const codigo = normalizarCodigo(codigoDoUsuario(usuario ?? usuarioEmCache()));
  if (!codigo) return false;

  return codigosLiberados.some((liberado) => normalizarCodigo(liberado) === codigo);
};

export const usarMock = (mock, usuario) =>
  mock != null && podeEscolherFonte(usuario) && localStorage.getItem("sm_data_source") !== "api";
